export default __webpack_public_path__ + "static/media/membership4.88cef137.jpg";